// extracted by mini-css-extract-plugin
module.exports = {"root":"az_PKc","topCaption":"az_QKc"};